/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PrintColorsDto } from '../models/PrintColorsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PrintColorsService {

    /**
     * @returns PrintColorsDto The collection of available print colors.
     * @throws ApiError
     */
    public static getShowPrintColors({
        locale,
    }: {
        /**
         * Locale
         */
        locale: string,
    }): CancelablePromise<Array<PrintColorsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/print-colors',
            query: {
                'locale': locale,
            },
        });
    }

}
